/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface MaintenanceRequest {
  id: number
  title: string
  description?: string
  tenant_id: number
  tenant_name?: string
  unit_name?: string
  status: 'pending' | 'in_progress' | 'completed'
  submitted_at: string
}

export interface MaintenanceState {
  list: MaintenanceRequest[]
  current: MaintenanceRequest | null
  loading: boolean
}

const maintenance: Module<MaintenanceState, RootState> = {
  namespaced: true,

  state: (): MaintenanceState => ({
    list: [],
    current: null,
    loading: false
  }),

  getters: {
    all: (state) => state.list,
    current: (state) => state.current,
    loading: (state) => state.loading
  },

  mutations: {
    SET_LIST (state, list: MaintenanceRequest[]) { state.list = list },
    SET_CURRENT (state, req: MaintenanceRequest) { state.current = req },
    SET_LOADING (state, val: boolean) { state.loading = val },
    ADD (state, req: MaintenanceRequest) { state.list.unshift(req) },
    UPDATE (state, updated: MaintenanceRequest) {
      const i = state.list.findIndex(r => r.id === updated.id)
      if (i !== -1) state.list.splice(i, 1, updated)
    }
  },

  actions: {
    async fetchAll ({ commit }, params?: { status?: string }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/maintenance', { params })
        commit('SET_LIST', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchOne ({ commit }, id: number) {
      const { data } = await api.get(`/maintenance/${id}`)
      commit('SET_CURRENT', data.data ?? data)
    },

    async create ({ commit }, payload: { tenant_id: number; title: string; description?: string }) {
      const { data } = await api.post('/maintenance', payload)
      commit('ADD', data.data ?? data)
      return data
    },

    async updateStatus ({ commit }, { id, status }: { id: number; status: string }) {
      const { data } = await api.patch(`/maintenance/${id}/status`, { status })
      commit('UPDATE', data.data ?? data)
      return data
    }
  }
}

export default maintenance
